import Tooltip from '@mui/material/Tooltip';
import BuildIcon from '@mui/icons-material/Build';
import LanguageIcon from '@mui/icons-material/Language';
import { FieldsSettingsIconsProps } from './FieldsSettingsTypes';
import { styled } from '@mui/system';

const TooltipStyled = styled(Tooltip)({
  color: '#757575',
  fontSize: '22px',
  left: '-16px',
  position: 'relative',
  top: '5px',
});

const FieldsSettingsIcons = ({ fieldDataTypeIsGlobal }: FieldsSettingsIconsProps): JSX.Element => {
  return (
    <>
      {fieldDataTypeIsGlobal !== undefined ? (
        <TooltipStyled
          title={fieldDataTypeIsGlobal ? 'Global Format' : 'Custom Format'}
          placement="top"
        >
          {fieldDataTypeIsGlobal ? (
            <LanguageIcon data-cy="world-icon" />
          ) : (
            <BuildIcon data-cy="wrench-icon" />
          )}
        </TooltipStyled>
      ) : null}
    </>
  );
};

export default FieldsSettingsIcons;
